// extracted by mini-css-extract-plugin
export default {"tableContent":"TableContent_tableContent__XFRst","padding":"TableContent_padding__BlGN-","inner":"TableContent_inner__xCAvl","isDay":"TableContent_isDay__RjVh0"};